// "Onde trabalho" (Texto 3 D4): o que é usado também fora da aba (Finanças), sem telas.
// As coleções e o painel ficam em modulos/ondeTrabalho.tsx.
import type { ModId, Reg } from '../store/types';
import { getDoc } from '../store/store';
import { junta, num, op, temNum } from './util';
import { N_, t } from '../lib/i18n';

export const SALARIO = N_('Salário fixo'), HORA_AULA = N_('Por hora-aula'), PLANTAO = N_('Por plantão'), ATENDIMENTO = N_('Por atendimento ou procedimento');
/** Abas que têm a parte "Onde trabalho". */
export const ABAS_ONDE_TRABALHO: ModId[] = ['professor', 'consultorio'];

/** A parte "Onde trabalho" está ligada nesta aba (Partes desta aba)? Desligada, some também de Finanças (nada é apagado). */
export const ondeTrabalhoLigado = (mod: ModId) => !(getDoc('ajustes').partesOcultas?.[mod] ?? []).includes('instituicao');

export const nomeDoMes = (ym: string) => { const [a, m] = ym.split('-').map(Number); return new Date(a, m - 1, 1).toLocaleDateString(undefined, { month: 'long', year: 'numeric' }); };

/** Diferença entre o recebido e o previsto (Parte B2): − = taxas/descontos, + = juros/multa. */
export function diferencaRecebida(r: Reg) {
  if (!r.c.recebido || !temNum(r.c.valorRecebido)) return 0;
  return Math.round((num(r.c.valorRecebido) - num(r.c.valor)) * 100) / 100;
}
/** O que entrou de fato (ou o previsto, enquanto não foi recebido). */
export const valorLiquido = (r: Reg) => (r.c.recebido && temNum(r.c.valorRecebido) ? num(r.c.valorRecebido) : num(r.c.valor));

/** Nome do recebimento: o que foi escrito ou "Salário · outubro de 2026". */
export function tituloRecebimento(r: Reg, inst: Reg | null | undefined) {
  return r.c.ref || junta(inst ? (inst.c.pagamento === SALARIO ? t('Salário') : op(inst.c.pagamento)) : '', r.c.mes && nomeDoMes(r.c.mes)) || t('Recebimento');
}
